<template>
  <Dialog
    v-model:visible="visible"
    id="modal-related-transactions"
    :header="$t('messages.relatedtransactions.title')"
    :style="{ width: '90vw' }"
    @hide="unload()"
    @show="load()"
  >
    <DataTable
      :loading="loading"
      :value="transactions"
      size="small"
      stripedRows
    >
      <template #loading>
        <div class="m-2">
          <ProgressSpinner class="align-middle"></ProgressSpinner>
          <strong>{{ $t('messages.loading') }}...</strong>
        </div>
      </template>

      <Column v-for="field in fields" :key="field.key" :field="field.key" :header="$t(`messages.transactions.fields.${field.key}`)" :footer="footerField(field.key)" class="text-sm" />
    </DataTable>
  </Dialog>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useHelpers } from '@/composables/useHelpers'
import { useTransactionStore } from '@/stores/transaction'
import {
  RELATED_TRANSACTION_FIELDS,
  TRANSACTION_DATE_FIELDS,
} from '../../constants'

const store = useTransactionStore()

const { t } = useI18n()

const props = defineProps({
  transaction: Object,
})

const visible = defineModel('visible', { required: true })

const { formatTransactionValue } = useHelpers()

const loading = ref(false)
const fields = RELATED_TRANSACTION_FIELDS.map(field => ({
  key: field,
  label: t(`messages.transactions.fields.${field}`),
  formatter: (value, key) => {
    return formatTransactionValue(key, value, $options.filters)
  },
}))
const transactions = ref([])
const listeners = ref([])
const totalSum = ref(0)

const footerField = field => {
  return field === 'notari_nimi'
    ? t('messages.relatedtransactions.total_sum')
    : field === 'tehingusumma'
      ? totalSum.value || ''
      : ''
}

const load = () => {
  loading.value = true
  store.loadRelatedTransactions(props.transaction).then(trs => {
    transactions.value = trs
    totalSum.value = trs.reduce((a, { tehingusumma }) => a + tehingusumma, 0)
    loading.value = false
  })
}

const unload = () => {
  transactions.value = []
  totalSum.value = 0
}
</script>

<style>
  #modal-related-transactions {
    .modal-body {
      padding: 0;
    }

    @media (min-width: 576px) {
      .modal-xxl {
        max-width: 97% !important;
        width: 97% !important;
      }
    }
  }
</style>
